import { render, staticRenderFns } from "./PrintArchivedDocument.vue?vue&type=template&id=e234c42c&scoped=true"
import script from "./PrintArchivedDocument.vue?vue&type=script&lang=js"
export * from "./PrintArchivedDocument.vue?vue&type=script&lang=js"
import style0 from "./PrintArchivedDocument.vue?vue&type=style&index=0&id=e234c42c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e234c42c",
  null
  
)

export default component.exports